import { Skeleton } from '@nextui-org/react'

export function OrderProductItemLoader() {
  return (
    <div className="border">
      <div className="grid divide-y divide-gray-200">
        <div className="flex gap-6 p-6 md:gap-10">
          <div className="aspect-[3/4] w-28 border md:w-40">
            <Skeleton className="h-full w-full">
              <div className="h-full w-full bg-default-200"></div>
            </Skeleton>
          </div>
          <div className="relative w-full text-sm md:w-[calc(100%_-_10rem)]">
            <div className="flex justify-between gap-6">
              <div className="w-4/5 space-y-2">
                <Skeleton className="w-4/5">
                  <div className="h-3 w-4/5 bg-default-200"></div>
                </Skeleton>
                <Skeleton className="w-3/5">
                  <div className="h-3 w-3/5 bg-default-200"></div>
                </Skeleton>
              </div>
              <Skeleton className="h-4 w-1/5">
                <div className="h-4 w-1/5 bg-default-200"></div>
              </Skeleton>
            </div>
            <div className="mt-4 grid gap-2">
              <div className="[&amp;>*:not(:first-child)]:pl-6 flex w-auto space-x-6 divide-x">
                <div className="flex w-auto gap-2">
                  <Skeleton className="w-20">
                    <div className="h-3 w-20 bg-default-200"></div>
                  </Skeleton>
                  <Skeleton className="w-10">
                    <div className="h-3 w-10 bg-default-200"></div>
                  </Skeleton>
                </div>
                <div className="flex w-auto gap-2">
                  <Skeleton className="w-20">
                    <div className="h-3 w-20 bg-default-200"></div>
                  </Skeleton>
                  <Skeleton className="w-10">
                    <div className="h-3 w-10 bg-default-200"></div>
                  </Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderProductItemLoader
